export type PublicPageName = 'about' | 'privacy' | 'terms' | 'support'

const CLEAN_PAGE_NAMES: PublicPageName[] = ['about', 'privacy', 'terms', 'support']

export function publicPageFromPath(pathname: string): PublicPageName | null {
  const segments = pathname.toLowerCase().split('/').filter(Boolean)
  const lastSegment = segments.at(-1) ?? ''

  if (CLEAN_PAGE_NAMES.includes(lastSegment as PublicPageName)) return lastSegment as PublicPageName
  if (lastSegment === 'about.htm' || lastSegment === 'about.html') return 'about'
  if (lastSegment === 'cookies.htm' || lastSegment === 'cookies.html' || lastSegment === 'privacy.htm' || lastSegment === 'privacy.html') return 'privacy'
  if (lastSegment === 'terms.htm' || lastSegment === 'terms.html') return 'terms'
  if (lastSegment === 'support.htm' || lastSegment === 'support.html') return 'support'
  return null
}

export function appBasePath(pathname: string): string {
  const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`
  const page = publicPageFromPath(normalized)
  if (page) {
    const cleanSuffix = new RegExp(`(?:${page}|about|cookies|privacy|terms|support)(?:\\.html?)?/?$`, 'i')
    return normalized.replace(cleanSuffix, '').replace(/\/?$/, '/')
  }
  return normalized.replace(/index\.html?$/i, '').replace(/\/?$/, '/')
}

export function publicPageHref(page: PublicPageName, pathname = window.location.pathname): string {
  return `${appBasePath(pathname)}${page}/`
}

export function homeHref(pathname = window.location.pathname): string {
  return appBasePath(pathname)
}

export function publicInformationMenuLinks(pathname = window.location.pathname) {
  return [
    { label: 'About', href: publicPageHref('about', pathname), dividerBefore: true },
    { label: 'Privacy & cookies', href: publicPageHref('privacy', pathname) },
    { label: 'Terms', href: publicPageHref('terms', pathname) },
    { label: 'Mapapal.com Home', href: homeHref(pathname), dividerBefore: true },
    { label: 'Legacy web', href: 'https://legacy.mapapal.com', external: true },
  ]
}
